// Auto-generated cornerstone translation for sv.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:36:52.994471+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Hästhanteringsapp: bästa valet för 2026 | EquiSight",
      description: "Jämför hästhanteringsappar för ägare, stall och avel. Upptäck varför EquiSight är den kompletta appen för din häst.",
      keywords: [
        "hästhanteringsapp",
        "stallhanteringsapp",
        "häst loggbok app",
        "app för att hantera flera hästar",
        "sto dräktighetsapp",
        "avelsprogram hästar",
        "bästa hästhanteringsapp",
      ],
    },
    hero: {
      eyebrow: "Väljarguide · hästhanteringsprogram",
      breadcrumbLabel: "Hästhanteringsapp",
      title: "Hästhanteringsapp: den kompletta väljarguiden för ägare, stall och uppfödare.",
      intro: "Inte bara en lista med funktioner — en ärlig jämförelse, en väljarguide och en inblick i vad en hästhanteringsapp verkligen måste klara av 2026. För en häst, för ett helt stall eller för ditt uppföderi.",
      pills: [
        {
          icon: "Users",
          label: "För ägare",
        },
        {
          icon: "Building2",
          label: "För stall",
        },
        {
          icon: "Baby",
          label: "För uppfödare",
        },
        {
          icon: "Share2",
          label: "För team",
        },
      ],
      ctas: [
        {
          label: "Kom igång gratis med 1 häst",
          href: "#start",
          primary: true,
        },
        {
          label: "Till jämförelsetabellen",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Varför en hästhanteringsapp blir allt viktigare.",
      lead: "Hästhantering är i praktiken splittrad: WhatsApp, kalender, Excel, foton på telefonen, ett papperspass, lösa fakturor och muntliga överenskommelser. Besvärligt redan med en häst. Med flera hästar, uppföderi eller delad omvårdnad uppstår luckor, missade avtal och diskussioner.",
      items: [
        "Vilket datum var vaccinationen nu igen?",
        "Vem betalade hovsmeden?",
        "Vilket sto ska kontrolleras idag?",
        "Har tränaren läst instruktionen från förra veckan?",
        "Sparade jag verkligen det fotodokumentet?",
        "Stämmer foderplanen som hänger i stallet fortfarande?",
      ],
    },
    what: {
      title: "Vad är en hästhanteringsapp?",
      lead: "En hästhanteringsapp är i grunden ett digitalt journalsystem per häst. Inga utspridda anteckningar — ett och samma ställe för hälsa, träning, utfodring, dokument, planering, påminnelser, kostnader, foton, videor och delad åtkomst. Alla runt hästen ser samma, aktuella information.",
      targetGroupsTitle: "Vem är en hästhanteringsapp till för?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privatägare",
          body: "En häst, en journal — hälsa, planering och historik i fickan.",
        },
        {
          icon: "Users",
          title: "Ägare med flera hästar",
          body: "Separata profiler, separat planering, delad uppgiftslista för hela teamet.",
        },
        {
          icon: "Building2",
          title: "Inackorderingsstall & ridhus",
          body: "Ägaråtkomst, skötselinstruktioner, delad kalender och uppgifter.",
        },
        {
          icon: "Baby",
          title: "Uppföderi",
          body: "Stocykel, dräktighet, hingsdata, stamtavla och föluveckling.",
        },
        {
          icon: "Target",
          title: "Tränare",
          body: "Överblick per häst, logga sessioner, sätta mål, analysera videor.",
        },
        {
          icon: "ClipboardList",
          title: "Yrkesverksamma",
          body: "Hovsmed, tandläkare, fysioterapeut eller veterinär — arbetar utifrån samma journal.",
        },
      ],
    },
    criteria: {
      title: "Vad ska en bra hästhanteringsapp uppfylla?",
      lead: "En app är inte bara snygg — den måste fungera praktiskt varje dag. Fem delar som inte får saknas i valet för 2026.",
      items: [
        {
          icon: "FileText",
          title: "Hästjournal per häst",
          body: "Uppgifter, ålder, ras, passinformation, ägare, stall, foton och dokument — allt kopplat till en och samma hästprofil.",
        },
        {
          icon: "Heart",
          title: "Hälsa och skötsel",
          body: "Vaccinationer, avmaskning, hovsmed, tandläkare, veterinär, behandlingar, medicinering och automatiska påminnelser före förfallodatum.",
        },
        {
          icon: "Activity",
          title: "Träning och framsteg",
          body: "Logga träningar, anteckningar, videor, tävlingsresultat, mål och framsteg per disciplin eller per häst.",
        },
        {
          icon: "Apple",
          title: "Utfodring och skötsel",
          body: "Foderplaner, tillskott, grovfoder, vikt, hull och den dagliga rutin som stallet behöver känna till.",
        },
        {
          icon: "Share2",
          title: "Dela med andra",
          body: "Åtkomst för ägare, skötare, tränare, stallägare eller yrkesperson — med behörighetshantering som passar vars och ens roll.",
        },
        {
          icon: "Calendar",
          title: "Planering och påminnelser",
          body: "En delad kalender med uppgifter, automatiska påminnelser och bekräftelse så att ingenting faller mellan stolarna.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andra hästhanteringsappar.",
      lead: "Den svenska marknaden domineras för närvarande av Stalmanager, LogMyHorse, EquineM och Happie Horse. Var och en har sina styrkor. Vi ställer de mest efterfrågade funktionerna bredvid varandra — ärligt och baserat på offentligt tillgänglig information.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Kom igång gratis",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Flera hästar",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hälsojournal",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Träning & framsteg",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Utfodring & tillskott",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planering & påminnelser",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokument per häst",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dela med team & behörigheter",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Avelsmodul (komplett)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Stocykel",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dräktighetsplanering + ultraljud",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Fölutveckling",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrering av yrkesverksamma",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach-insikter",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lämplig för ägare",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Lämplig för uppföderi",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lämplig för stall/ridhus",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Jämförelse baserad på offentligt tillgängliga funktioner i januari 2026. Konkurrenterna är också bra verktyg; EquiSight är byggt för att kombinera alla moduler i en och samma app.",
    },
    why: {
      title: "Varför EquiSight är annorlunda.",
      lead: "En loggbok registrerar. EquiSight kombinerar hästhantering, träning, utfodring, hälsa, tävlingar, yrkesverksamma och avel i en modern app — och går ett steg längre med insikter.",
      points: [
        {
          icon: "Heart",
          title: "En app för hela hästens liv",
          body: "Från föl till sporthäst, avelssto eller pensionär. Journalen växer med din häst — ingenting försvinner på vägen.",
        },
        {
          icon: "Sparkles",
          title: "Inte bara data, även mönster",
          body: "EquiCoach kombinerar utveckling, återkommande besvär, träning och utfodring — så att du ser signaler i tid, inte enstaka notiser.",
        },
        {
          icon: "Share2",
          title: "Byggt för samarbete",
          body: "Ägare, stallägare, tränare, hovsmed och andra yrkesverksamma arbetar utifrån samma hästjournal — med de behörigheter som passar deras roll.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nisch · uppföderi",
      title: "Hästhantering för uppfödare.",
      lead: "Många konkurrenter nämner avel på en enda rad. EquiSight byggde en komplett avelsmodul — eftersom uppfödaren sällan är slutanvändaren av en generell app, men har ett större behov av planering än någon annan.",
      items: [
        "Följ stocykeln dagligen",
        "Inseminationsdatum + hingstuppgifter",
        "Dräktighetskontroll med ultraljud",
        "Förväntat földatum + varningar",
        "Fölutveckling per månad",
        "Stamtavla och härstamning",
        "Anteckningar per sto",
        "Översikt över alla dräktiga ston",
      ],
      ctaLabel: "Se avelsmodulen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nisch · stall & ridhus",
      title: "Hästhantering för flera hästar och inackorderingsstall.",
      lead: "Med flera hästar handlar det mindre om data och mer om kommunikation. Varje ägare har egna önskemål, rutiner, foderavtal och medicinska noteringar. Varje medarbetare ska kunna hitta det utan att leta.",
      cards: [
        {
          t: "Hästar per ägare",
          d: "Varje ägare ser bara sin/sina häst(ar).",
        },
        {
          t: "Skötselinstruktioner",
          d: "Synliga per häst för stallet.",
        },
        {
          t: "Delad kalender",
          d: "Hovsmed, veterinär och tävlingar i en vy.",
        },
        {
          t: "Uppgiftslista",
          d: "Tilldela medarbetare, med bekräftelse.",
        },
        {
          t: "Ägaråtkomst",
          d: "Kunder ser sin häst i egen app.",
        },
        {
          t: "Nödkontakter",
          d: "Alltid tillgängliga vid stress i stallet.",
        },
      ],
      ctaLabel: "Se ridhusmödulen",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Från WhatsApp, Excel och whiteboard till EquiSight.",
      lead: "Konkret: så här förändras din dagliga hästhantering.",
      rows: [
        {
          before: "WhatsApp-grupper",
          after: "Strukturerade anteckningar per häst",
        },
        {
          before: "Excel-ark",
          after: "Levande hästjournal med historik",
        },
        {
          before: "Whiteboard i stallet",
          after: "Delad planering på din telefon",
        },
        {
          before: "Lösa foton på kameran",
          after: "Media kopplat till din häst",
        },
        {
          before: "Muntliga överenskommelser",
          after: "Uppgifter och påminnelser med bekräftelse",
        },
        {
          before: "Papperspass borttappat",
          after: "Dokument alltid till hands",
        },
      ],
    },
    helper: {
      title: "Vilken hästhanteringsapp passar dig?",
      lead: "Svara på dessa 5 frågor och du får en ärlig rekommendation — även om den inte alltid är EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Har du en häst eller flera hästar?",
          options: [
            {
              label: "En häst",
              score: 1,
            },
            {
              label: "2–5 hästar",
              score: 2,
            },
            {
              label: "Fler än 5 hästar",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Hanterar du hästar åt kunder eller andra?",
          options: [
            {
              label: "Nej, bara mina egna hästar",
              score: 0,
            },
            {
              label: "Ibland — för familj eller bekanta",
              score: 1,
            },
            {
              label: "Ja, professionellt (stall / ridhus)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Vill du hålla koll på avel och dräktighet?",
          options: [
            {
              label: "Inte relevant",
              score: 0,
            },
            {
              label: "Ibland — enstaka avel",
              score: 1,
            },
            {
              label: "Ja, jag är (eller blir) uppfödare",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Samarbetar du med tränare, skötare eller yrkesperson?",
          options: [
            {
              label: "Nej, jag gör allt själv",
              score: 0,
            },
            {
              label: "Ja, med 1 person",
              score: 1,
            },
            {
              label: "Ja, med flera personer",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vill du bara registrera eller även få insikter?",
          options: [
            {
              label: "Bara registrera",
              score: 1,
            },
            {
              label: "Registrera + planering",
              score: 2,
            },
            {
              label: "Registrera + planering + insikter",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "En enkel loggbok räcker — och växer med dig.",
          body: "För en häst utan delad omvårdnad passar alla hästhanteringsappar. EquiSight startar gratis med 1 häst, så du tar ingen risk. Om du senare vill lägga till fler hästar, en tränare eller avel finns allt redan på plats.",
          cta: "Kom igång gratis med 1 häst",
        },
        mid: {
          title: "EquiSight passar bra för din situation.",
          body: "Du har flera behov (flera hästar, samarbete eller insikter). De flesta konkurrenter täcker 1–2 moduler; EquiSight kombinerar dem i en och samma app utan att du behöver koppla ihop separata verktyg.",
          cta: "Se vad EquiSight kan",
        },
        high: {
          title: "EquiSight är det mest logiska valet.",
          body: "Din situation kombinerar flera hästar, samarbete, avel och/eller insikter. Det är precis där EquiSight gör skillnad — inga utspridda verktyg, utan en hästjournal för allt och alla runt hästen.",
          cta: "Kom igång gratis med EquiSight",
        },
      },
    },
    faqTitle: "Vanliga frågor om hästhanteringsappar",
    faq: [
      {
        q: "Vad är den bästa hästhanteringsappen?",
        a: "Den bästa hästhanteringsappen beror på din situation. För en enkel loggbok passar flera appar. Vill du kombinera hälsa, träning, utfodring, dokument, avel, planering och samarbete är EquiSight byggt som en komplett lösning där allt samlas i en och samma journal.",
      },
      {
        q: "Kan jag hantera flera hästar i en och samma app?",
        a: "Ja. En bra hästhanteringsapp måste stödja flera hästar, inklusive ägare, skötare, rutiner, dokument, avtal och påminnelser per häst. EquiSight är designat för detta från första raden kod — hästar är individuella journaler, inte rader i en lista.",
      },
      {
        q: "Är EquiSight lämplig för uppfödare?",
        a: "Ja. EquiSight kan konfigureras med avelfunktioner som stocykel, inseminationsdatum, dräktighetskontroll, hingstuppgifter, stamtavla, förväntat földatum och fölutveckling. Det är precis det område där de flesta konkurrerande appar inte alls eller knappt erbjuder funktioner.",
      },
      {
        q: "Kan jag dela uppgifter med min tränare eller hovsmed?",
        a: "Ja. Syftet med EquiSight är att relevant information kan delas säkert med personer runt hästen — tränare, hovsmed, tandläkare, veterinär, fysioterapeut, skötare eller ägare. Varje person får bara de behörigheter som behövs för deras roll.",
      },
      {
        q: "Varför inte bara använda WhatsApp eller Excel?",
        a: "WhatsApp och Excel fungerar så länge det är enkelt. Så snart du har flera hästar, avtal, dokument, behandlingar, ägare eller aveldata blir det felkänsligt: information sprids, det tar tid att söka tillbaka och muntliga överenskommelser försvinner. En hästhanteringsapp samlar allt per häst med automatiska påminnelser.",
      },
      {
        q: "Vad kostar EquiSight?",
        a: "Du kan komma igång gratis med 1 häst. Vill du hantera flera hästar, aktivera avel eller ge yrkesverksamma åtkomst finns prisvärda Premium-planer. Se de aktuella alternativen på prissidan.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Avels­programvara häst: komplett jämförelse 2026",
      description: "Jämför avels­programvara för hästar: sto­cykel, dräktighet, hingstkval och föl. Upptäck varför EquiSight är den kompletta avels­appen.",
      keywords: [
        "avels­programvara häst",
        "sto­cykel app",
        "sto dräktighet app",
        "föl­registrering app",
        "stam­boks­app häst",
        "betäcknings­planering häst",
        "hingstkval app",
      ],
    },
    hero: {
      eyebrow: "Valguide · avels­programvara",
      breadcrumbLabel: "Avels­programvara",
      title: "Avels­programvara för hästar: den kompletta jämförelsen för 2026.",
      intro: "Ett avelsto förtjänar mer än en generell häst­hanterings­app. Jämför avelsfunktionerna hos de mest kända verktygen, ta reda på vad du verkligen bör titta på, och välj medvetet den programvara som passar ditt stud — stort eller litet.",
      pills: [
        {
          icon: "Baby",
          label: "Sto­cykel",
        },
        {
          icon: "Heart",
          label: "Dräktighets­kontroll",
        },
        {
          icon: "Sparkles",
          label: "Föl­utveck­ling",
        },
        {
          icon: "FileText",
          label: "Stam­bok",
        },
      ],
      ctas: [
        {
          label: "Kom igång gratis med avels­modulen",
          href: "#start",
          primary: true,
        },
        {
          label: "Till jämförelse­tabellen",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Varför en vanlig häst­hanterings­app inte räcker för avel.",
      lead: "De flesta häst­sport­appar är utformade för en sport- eller fritidshäst. Avel har en helt annan rytm: brunst, insemination, dräktighets­kontroll, ultraljud, föl­kalender, stamtavla och försäljning. Ett Excel-ark tappar greppet efter 2 säsonger — och med flera ston förlorar du snabbt över­blicken.",
      items: [
        "När var Bonitas senaste cykel egentligen?",
        "Vilken hingst är planerad för betäckning nästa säsong?",
        "Är det 21-dagars ultraljudet inbokat?",
        "Vilka föl från 2024 är redan sålda?",
        "Var finns stamtavle­diagrammet upp till morfarens far?",
        "Var är DNA-proverna och pass­uppgifterna?",
      ],
    },
    what: {
      title: "Vad är avels­programvara för hästar?",
      lead: "Avels­programvara är ett specialiserat journal­system per sto och hingst, kombinerat med en avels­årskalender, dräktighets­planering, föl­registrering och stamtavle­visning. Inte en generell häst­dagbok, utan ett verktyg som förstår avelscykeln: från första brunst till avvänjning.",
      targetGroupsTitle: "För vilken typ av uppfödare är avels­programvara avsedd?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobby­uppfödare (1–3 ston)",
          body: "En eller två betäckningar per år — överblick utan Excel-akrobatik.",
        },
        {
          icon: "Building2",
          title: "Litet stud (4–10 ston)",
          body: "En avels­årsplan med cykel, insemination, dräktighets­kontroller och föl­journal.",
        },
        {
          icon: "Users",
          title: "Professionellt stud (10+)",
          body: "Flera medarbetare, hingstkval per sto, försäljning och marknadsföring.",
        },
        {
          icon: "Target",
          title: "Hingst­ägare",
          body: "Bestell­historik, sperma­statistik och kalender per hingst.",
        },
        {
          icon: "Heart",
          title: "Embryo­transplantation",
          body: "Donor- och mottagarsto som kopplad journal, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Stam­boks­registrering",
          body: "DNA-prover, pass­dokument och stamtavle­uppgifter.",
        },
      ],
    },
    criteria: {
      title: "Vad ska bra avels­programvara uppfylla?",
      lead: "Inte alla 'avels­funktioner' i en häst­app är likvärdiga. Fem nyckel­områden där uppfödare förlorar mycket tid — och där programvara verkligen gör skillnad.",
      items: [
        {
          icon: "Calendar",
          title: "Sto­cykel & brunst",
          body: "Daglig logg, förutsägande ägglossning, framrullning per cykel och automatiska påminnelser.",
        },
        {
          icon: "Heart",
          title: "Insemination & dräktighets­kontroll",
          body: "Betäcknings- och inseminations­datum, hingst­uppgifter, 14-dagars ultraljud, 21-dagars ultraljud, 60-dagars ultraljud och könsbedömning.",
        },
        {
          icon: "Baby",
          title: "Föl­utveck­ling",
          body: "Födselo­uppgifter, vikts­graf, avmasknings­schema, avvänjnings­tidpunkt, pass­registrering.",
        },
        {
          icon: "FileText",
          title: "Stamtavla & dokument",
          body: "Stamtavle­visning upp till 4–5 generationer, DNA, pass­nummer och stam­boks­status.",
        },
        {
          icon: "Target",
          title: "Hingstkval & matchning",
          body: "Filtrera på disciplin, linjer, hingst­uppgifter och historisk framgång — inte bara vad en hingst­ägare marknadsför.",
        },
        {
          icon: "Share2",
          title: "Sam­arbete veterinär/inseminator",
          body: "Ultraljud, prover och statusar delas direkt med kliniken som arbetar med dina ston.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs annan avels­programvara.",
      lead: "Svenska sök­resultat för avels­programvara visar ofta generiska häst­appar som nämner avel i en enda mening. Vi jämför ärligt vilka verktyg som verkligen har ett komplett avels­flöde.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Kom igång gratis",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Logga sto­cykel",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminations­datum + hingst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultraljud & dräktighets­kontroll",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Förväntad föl­datum",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Föl­journal (vikt/tillväxt)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stamtavla upp till 4–5 generationer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & pass­registrering",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hingstkval / matchning",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryo­transplantation",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Fler­sto­överblick",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dela med veterinär",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrerat med generell journal",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Försäljning & marknadsföring av föl",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Jämförelse baserad på offentligt tillgängliga funktioner i januari 2026. EquineGenie är stark inom avel men svagare på mobil och generell häst­hantering. EquiSight kombinerar båda.",
    },
    why: {
      title: "Varför EquiSight servar uppfödare på ett annat sätt.",
      lead: "Många uppfödare arbetar med separat avels­programvara och en separat häst­hanterings­app. EquiSight kombinerar båda — utan att du växlar mellan appar eller matar in data dubbelt.",
      points: [
        {
          icon: "Heart",
          title: "Avels­sto är också en vanlig häst",
          body: "Avelsstoet har en avels­årsjournal och en vanlig häst­journal — hälsa, vaccinationer, hovsmidning. En app, alla moduler.",
        },
        {
          icon: "Sparkles",
          title: "Förutsägande i stället för reaktivt",
          body: "Cykel­förutsägelse, dräktighets­milstolpe­påminnelser och föl­kalender — automatiskt baserat på dina data.",
        },
        {
          icon: "Share2",
          title: "Alla runt aveln",
          body: "Inseminator, hingst­ägare, veterinär, köpare, stam­bok — alla med åtkomst med rätt behörighet.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per disciplin · cykel till avvänjning",
      title: "Vad en avels­journal i EquiSight innehåller.",
      lead: "Per sto får du en komplett avels­journal, kopplad till dess vanliga häst­journal.",
      items: [
        "Daglig cykel­logg med förutsägelse",
        "Insemination/betäckning + hingst­uppgifter",
        "Ultraljuds­tidslinje (14/21/60 dagar + kön)",
        "Dräktighets­milstolpar med automatiska påminnelser",
        "Förväntad föl­datum och förberedelse",
        "Föl­journal från födseln",
        "Stamtavla till mor- och farföräldrar med klick­navigering",
        "DNA-prov, pass, stam­boks­status",
        "Försäljnings­pipeline med intressenter",
        "Hingstkvalshistorik per sto",
      ],
      ctaLabel: "Se avels­modulen",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "För hela studet",
      title: "Överblick för flera ston och hingstar.",
      lead: "När du föder upp mer än 2–3 ston blir överblick över alla cykler och dräktigheter avgörande.",
      cards: [
        {
          t: "Cykel­dashboard",
          d: "Alla ston sida vid sida, med cykel­stadium och nästa åtgärd.",
        },
        {
          t: "Dräktighets­pipeline",
          d: "Vilka ston befinner sig var i dräktighets­milstolparna?",
        },
        {
          t: "Föl­kalender",
          d: "Förväntade födslar per månad, med logistik anpassad efter det.",
        },
        {
          t: "Hingst­portfölj",
          d: "Egna hingstar eller fasta inseminatorer med bestell­historik.",
        },
        {
          t: "Stamtavle­graf",
          d: "Förfaders­analys över flera generationer och linjer.",
        },
        {
          t: "Försäljnings­dashboard",
          d: "Vilka föl är sålda, reserverade eller fortfarande tillgängliga.",
        },
      ],
    },
    beforeAfter: {
      title: "Från Excel + kalender till EquiSight avel.",
      lead: "Konkret: så här förändras din avels­säsong.",
      rows: [
        {
          before: "Cykel i lösa anteckningar",
          after: "Daglig logg med förutsägelse",
        },
        {
          before: "Ultraljud via WhatsApp till inseminator",
          after: "Delad journal med foton",
        },
        {
          before: "Dräktighets­datum i kalender",
          after: "Automatiska milstolpe­påminnelser",
        },
        {
          before: "Föl­pass i lådan",
          after: "Dokument kopplat till föl­profil",
        },
        {
          before: "Stamtavla på papper",
          after: "Klickbar stamtavla upp till 4–5 generationer",
        },
        {
          before: "Försäljnings­annons på Marktplaats",
          after: "Försäljnings­pipeline med intresse­lista",
        },
      ],
    },
    helper: {
      title: "Vilken avels­programvara passar dig?",
      lead: "5 frågor för att avgöra om du behöver en komplett avels­app eller om ett hobby­verktyg räcker.",
      questions: [
        {
          id: "mares",
          q: "Hur många avels­ston hanterar du?",
          options: [
            {
              label: "1 sto",
              score: 1,
            },
            {
              label: "2–5 ston",
              score: 2,
            },
            {
              label: "Mer än 5 ston",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Hur ofta föder du upp per år?",
          options: [
            {
              label: "Sällan (vart några år)",
              score: 0,
            },
            {
              label: "Varje år 1–2 betäckningar",
              score: 2,
            },
            {
              label: "Varje år 3+ betäckningar",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hur inseminerar/betäcker du?",
          options: [
            {
              label: "Naturlig betäckning",
              score: 1,
            },
            {
              label: "AI färskt/kylt sperma",
              score: 2,
            },
            {
              label: "ET eller fryst sperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Samarbetar du med veterinär/inseminator?",
          options: [
            {
              label: "En fast person",
              score: 1,
            },
            {
              label: "Flera kliniker",
              score: 2,
            },
            {
              label: "Internationellt nätverk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Vad registrerar du idag?",
          options: [
            {
              label: "Excel eller papper",
              score: 1,
            },
            {
              label: "Generell häst­hanterings­app",
              score: 2,
            },
            {
              label: "Ingenting strukturerat",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ett hobby­verktyg eller Excel räcker — men EquiSight är ändå smidigt.",
          body: "För 1 sto med naturlig betäckning vart några år är en avancerad avels­modul överdrivet. EquiSight är gratis att starta och du aktiverar avels­modulen bara det år du betäcker — utan uppgraderings­krav.",
          cta: "Kom igång gratis",
        },
        mid: {
          title: "EquiSight avel är rätt verktyg.",
          body: "Du har flera ston eller flera avels­metoder — det är generella häst­appar inte byggda för. EquiSight kombinerar avel och allmän skötsel så att du inte växlar mellan två verktyg.",
          cta: "Se avels­modulen",
        },
        high: {
          title: "EquiSight är byggt för ditt stud.",
          body: "Flera ston, ET eller fryst sperma, internationellt team — de flesta verktyg räcker inte till här. EquiSight skalar upp till stud­nivå utan att du staplar extra licenser.",
          cta: "Prata med oss om ett Stud­abonnemang",
        },
      },
    },
    faqTitle: "Vanliga frågor om avels­programvara",
    faq: [
      {
        q: "Vad är den bästa avels­programvaran för hästar?",
        a: "För 1 sto utan komplicerad avels­metod räcker många verktyg. Från 2–3 ston, användning av AI eller ET, eller samarbete med veterinär och stam­bok blir en komplett avels­modul avgörande. EquiSight kombinerar avel med generell häst­hantering i en app, så att du inte behöver växla.",
      },
      {
        q: "Vilka avels­funktioner behöver jag verkligen?",
        a: "Minst: cykel­logg, inseminations-/betäcknings­uppgifter, dräktighets­kontroll­milstolpar och föl­journal. Valfritt men kraftfullt: stamtavle­visning, hingstkvalsarkiv, DNA/pass och försäljnings­pipeline.",
      },
      {
        q: "Kan EquiSight förutsäga ett stos cykel?",
        a: "Ja. EquiSight använder tidigare cykel­data för att visa förutsedd ägglossning, så att du planerar insemination eller betäckning vid rätt tidpunkt — utan dagligt gissande.",
      },
      {
        q: "Fungerar EquiSight för embryo­transplantation?",
        a: "Ja. Donor- och mottagarsto får kopplade journaler, ET-kalender och delade milstolpar med kliniken. På så sätt tappar du ingen tidslinje i det komplexa ET-flödet.",
      },
      {
        q: "Kan jag importera mina befintliga avels­data?",
        a: "Du kan mata in cykel, betäckningar och föl­data manuellt eller i bulk via CSV. För aktiva stud hjälper vi till med en engångs­migrering om du har data från flera säsonger.",
      },
      {
        q: "Hur delar jag journal med min veterinär eller inseminator?",
        a: "Per person tilldelas åtkomst med en roll: veterinär, inseminator, hingst­ägare eller stam­boks­handläggare. Alla ser bara den information som behövs för sin roll — ingen fullständig åtkomst krävs.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Ridskola mjukvara: komplett jämförelse & köpguide 2026",
      description: "Jämför ridskola mjukvara för lektioner, ryttare, hästar och administration. Upptäck vilken app som passar din ridskola eller inackorderingsstall.",
      keywords: [
        "ridskola mjukvara",
        "stallhantering app",
        "ridskola administrationsverktyg",
        "lektionsplanering ridskola",
        "inackorderingsstall mjukvara",
        "ryttaradministration",
        "hästadministration ridskola",
      ],
    },
    hero: {
      eyebrow: "Köpguide · ridskola mjukvara",
      breadcrumbLabel: "Ridskola mjukvara",
      title: "Ridskola mjukvara: den kompletta köpguiden för ridskolor och inackorderingsstall.",
      intro: "Lektionsplanering, ryttaradministration, hästhantering, fakturering och kommunikation — bra ridskola mjukvara samlar allt på ett ställe. Jämför de mest kända alternativen och ta reda på vilket som passar just ditt stall eller din ridskola.",
      pills: [
        {
          icon: "Calendar",
          label: "Lektionsplanering",
        },
        {
          icon: "Users",
          label: "Ryttare & kunder",
        },
        {
          icon: "Heart",
          label: "Hästvård",
        },
        {
          icon: "CreditCard",
          label: "Fakturering",
        },
      ],
      ctas: [
        {
          label: "Boka en demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Till jämförelsetabellen",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Varför spridda verktyg gör ridskolan långsam.",
      lead: "De flesta ridskolor körs på ett lapptäcke: lektionsplanering på en whiteboard, ryttarregistrering i Excel, fakturering i ett separat verktyg, hästvård via WhatsApp och ägarkontakt via privata meddelanden. Under en stressig vecka uppstår dubbelbokningar, glömda fakturor eller hästar som inte vet vilken ryttare de får.",
      items: [
        "Vem har lektion med Jasmin just nu?",
        "Vilken ryttare har inte betalat för mars?",
        "Vilken häst får inte användas den här veckan?",
        "Vilka är nödkontakterna för eleverna?",
        "Har ägaren till Stardust fått hovsmidsfakturan?",
        "Vilken häst står i vilken box?",
      ],
    },
    what: {
      title: "Vad är ridskola mjukvara?",
      lead: "Ridskola mjukvara kombinerar lektionsplanering, ryttaradministration, hästhantering, fakturering och kommunikation i ett enda verktyg. Ingen Excel-akrobatik eller WhatsApp-kaos — bara ett ställe där ridskolan arbetar och ägare/ryttare kan följa med.",
      targetGroupsTitle: "Vilken typ av verksamhet är ridskola mjukvara avsedd för?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Liten ridskola (1–15 hästar)",
          body: "Framför allt lektionsplanering och betalningar — administration utan huvudvärk.",
        },
        {
          icon: "Users",
          title: "Medelstor ridskola (15–40 hästar)",
          body: "Flera instruktörer, lektionsplanering + hästschema + ryttaradministration.",
        },
        {
          icon: "ClipboardList",
          title: "Stort rid- och inackorderingsstall (40+)",
          body: "Fullständig drift inklusive fakturering, foder- och hovsmidsplanering.",
        },
        {
          icon: "Heart",
          title: "Inackorderingsstall",
          body: "Ägarportal, individuella vårdanvisningar, delad kalender.",
        },
        {
          icon: "Target",
          title: "Träningsstall för hoppning",
          body: "Tävlingsplanering, träning per häst, kundkontakt.",
        },
        {
          icon: "FileText",
          title: "Hippiska företagare",
          body: "Mix av lektioner + inackordering + klinik + handel — allt från ett system.",
        },
      ],
    },
    criteria: {
      title: "Vad ska bra ridskola mjukvara uppfylla?",
      lead: "En snygg app betyder ingenting om dina medarbetare inte vill använda den. Fem praktiska kriterier som gör skillnaden mellan framgång och frustration.",
      items: [
        {
          icon: "Calendar",
          title: "Lektionsplanering på flera nivåer",
          body: "Nybörjare/avancerad, dressyr/hoppning, häst-kopplingar och instruktörskalendrar — alla synliga bredvid varandra.",
        },
        {
          icon: "Users",
          title: "Ryttaradministration",
          body: "Profiler, nivå, abonnemang, lektionskort och familjemedlemskopplingar för unga ryttare.",
        },
        {
          icon: "Heart",
          title: "Hästschema",
          body: "Vilken häst används hur ofta, med vila-, skade- och löpperioder.",
        },
        {
          icon: "CreditCard",
          title: "Fakturering & abonnemang",
          body: "Månatliga abonnemang, lektionskort, enstaka lektioner och automatisk autogiro.",
        },
        {
          icon: "Share2",
          title: "Ägarportal (inackorderingsstall)",
          body: "Ägare ser sin häst i en egen app — kalender, kostnader, hovsmid och anteckningar utan att behöva ringa.",
        },
        {
          icon: "Bell",
          title: "Kommunikation & påminnelser",
          body: "Automatiska lektionspåminnelser, betalningsaviseringar, hovsmidstillkännagivanden — utan att skicka meddelanden manuellt.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs annan ridskola mjukvara.",
      lead: "Många ridskoleverktyg är starka på lektionsplanering eller fakturering, men sällan på hästvård och ägarkommunikation tillsammans. Vi ställer dem ärligt bredvid varandra.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Gratis start / provperiod",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Lektionsplanering",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Flera instruktörer",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ryttaradministration",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hästschema",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hästvård (vaccin/hovsmid)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lektionskort / abonnemang",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Onlinebetalningar",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatisk fakturering",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Ägarportal (inackordering)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hovsmid/veterinärintegration",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS-påminnelser",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Tävlingsplanering",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lämplig för inackorderingsstall",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Jämförelse baserad på offentligt tillgängliga funktioner i januari 2026. Stalmanager är stark inom administration, EquiSight utmärker sig inom inackorderingsflöde + hästvård + ägarportal.",
    },
    why: {
      title: "Varför EquiSight är annorlunda för ridskolor och inackorderingsstall.",
      lead: "EquiSight går längre än en lektionsplanerare. Vi ser en ridskola som en komplett verksamhet: hästar, människor, kommunikation och ekonomi — allt beroende av varandra.",
      points: [
        {
          icon: "Heart",
          title: "Hästen i centrum, inte kalendern",
          body: "Varje häst har sin egen journal. Lektionsinsats, hälsa, hovsmid och tävlingar i en tidslinje — inte 3 separata verktyg.",
        },
        {
          icon: "Share2",
          title: "Ägare kan följa med utan att ringa",
          body: "Inackorderingsägare har sin egen vy: kostnader, planering, foton och anteckningar — sparar 5–10 telefonsamtal per vecka.",
        },
        {
          icon: "Bell",
          title: "Automatisk kommunikation",
          body: "Lektionspåminnelse, vaccinpåminnelse, faktura — automatiskt, via app/e-post/SMS. Inget mer broadcast-WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "För inackorderingsstallet",
      title: "Vad ett inackorderingsstall får med EquiSight.",
      lead: "Inackorderingsstall har unika utmaningar som vanlig ridskola mjukvara inte löser.",
      cards: [
        {
          t: "Ägarportal",
          d: "Varje ägare ser bara sin egen häst (eller sina hästar), kalender och kostnader.",
        },
        {
          t: "Vårdanvisningar per häst",
          d: "Foder, grovfoder, tillskott, täckschema — synligt för stallpersonalen.",
        },
        {
          t: "Delad kalender",
          d: "Hovsmid, veterinär och ägarbesök i en gemensam vy.",
        },
        {
          t: "Förbrukningskostnader per häst",
          d: "Strö, foder, kraftfoder debiteras per ägare.",
        },
        {
          t: "Nödkontakter för hästen",
          d: "Ägare + veterinär + hovsmid alltid tillgängliga för stallpersonalen.",
        },
        {
          t: "Beteshantering",
          d: "Vilka hästar går på bete, vilar eller rehabiliteras?",
        },
      ],
    },
    beforeAfter: {
      title: "Från whiteboard + Excel till EquiSight.",
      lead: "Konkret: så förändras en arbetsvecka på ridskolan.",
      rows: [
        {
          before: "Whiteboard med lektionsplaneringen",
          after: "Live-planering per instruktör",
        },
        {
          before: "Excel med ryttare och lektionsanteckningar",
          after: "Kund-CRM med lektionshistorik",
        },
        {
          before: "WhatsApp till ägare",
          after: "Ägarportal för deras häst",
        },
        {
          before: "Månadsvis autogiro manuellt",
          after: "Automatisk fakturering + iDEAL",
        },
        {
          before: "Hästvård på en papperstavla",
          after: "Vårdanvisningar per häst, delade",
        },
        {
          before: "Muntlig överenskommelse med hovsmid",
          after: "Hovsmidsplanering med bekräftelser",
        },
      ],
    },
    helper: {
      title: "Vilken ridskola mjukvara passar dig?",
      lead: "5 frågor för att se om EquiSight är rätt plattform för din ridskola eller ditt inackorderingsstall.",
      questions: [
        {
          id: "size",
          q: "Hur många hästar har du i din verksamhet?",
          options: [
            {
              label: "Färre än 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Fler än 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Vad är din huvudsakliga verksamhet?",
          options: [
            {
              label: "Framför allt ge lektioner",
              score: 1,
            },
            {
              label: "Inackorderingsstall (hästar i inackordering)",
              score: 3,
            },
            {
              label: "Mix av lektioner + inackordering",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Hur många instruktörer arbetar du med?",
          options: [
            {
              label: "Bara jag själv",
              score: 1,
            },
            {
              label: "2–3 instruktörer",
              score: 2,
            },
            {
              label: "4 eller fler",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Hur hanterar du din fakturering idag?",
          options: [
            {
              label: "Manuellt (Word/Excel)",
              score: 3,
            },
            {
              label: "Separat bokföringsprogram",
              score: 2,
            },
            {
              label: "Integrerat i lektionsverktyget",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Hur kommunicerar du med ägare?",
          options: [
            {
              label: "Personligen / WhatsApp",
              score: 3,
            },
            {
              label: "E-post + WhatsApp",
              score: 2,
            },
            {
              label: "Ägarportal i verktyget",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ett enkelt verktyg eller Excel kan räcka ett tag — men EquiSight växer med dig.",
          body: "För ett litet lektionsföretag med en instruktör och lite inackordering behövs inget avancerat paket direkt. EquiSight startar gratis och växer med din ridskola — ingen migrations­smärta om några år.",
          cta: "Starta gratis",
        },
        mid: {
          title: "EquiSight är en naturlig uppgradering för din ridskola.",
          body: "Flera instruktörer, en mix av lektioner och inackordering, eller fakturering som i dag är fristående — EquiSight samlar det i ett arbetsflöde. Framför allt sparar ägarportalen mycket ad hoc-kommunikation.",
          cta: "Boka en demo",
        },
        high: {
          title: "EquiSight är byggt för din skala.",
          body: "Inackorderingsstall + lektioner + flera instruktörer är precis där EquiSight skiljer sig från klassiska ridskolaverktyg. Ägarportalen och hästvårdsintegrationen sparar timmar av administration och kommunikation varje vecka.",
          cta: "Boka en demo för ditt stall",
        },
      },
    },
    faqTitle: "Vanliga frågor om ridskola mjukvara",
    faq: [
      {
        q: "Vad är den bästa ridskola mjukvaran?",
        a: "För ren lektionsplanering finns det flera bra alternativ. Så snart du behöver ett inackorderingsstall, flera instruktörer eller spårning av hästvård blir EquiSight den kompletta lösningen — ingen jonglering med verktyg, allt på ett ställe.",
      },
      {
        q: "Kan jag importera befintliga kunder och lektioner?",
        a: "Ja. Kunduppgifter och lektionsscheman kan importeras via CSV. Vi hjälper aktiva ridskolor med en engångsmigration så att du inte behöver lägga in 200 ryttare manuellt.",
      },
      {
        q: "Fungerar det även för ett inackorderingsstall utan lektioner?",
        a: "Ja. Inackorderingsläget stänger av lektioner och fokuserar på ägarportal, foder/vård, hovsmidsplanering och kostnadsdebitering per häst.",
      },
      {
        q: "Kan ryttare själva anmäla sig och betala?",
        a: "Ja. Ryttare kan via ett eget konto se vilka lektioner som är öppna, anmäla sig, betala lektionsavgift med iDEAL och köpa lektionskort.",
      },
      {
        q: "Hur är det med integriteten för häst- och ägaruppgifter?",
        a: "Varje person har en roll (ägare, ryttare, instruktör, anställd). Per roll ser du bara det du behöver. Ägare ser bara sin häst, ryttare ser bara sina egna lektioner.",
      },
      {
        q: "Kan EquiSight kopplas till mitt bokföringsprogram?",
        a: "Ja, kopplingar till Exact, Moneybird och e-Boekhouden finns tillgängliga. Fakturor flödar då automatiskt in i din bokföring.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Tränarapp häst: jämförelse & vägledning för coacher 2026",
      description: "Jämför tränarappar för häst och ryttare: träningslogg, video, mål, protokollanalys och kundhantering. Hitta rätt verktyg för coacher.",
      keywords: [
        "tränarapp häst",
        "instruktörsapp",
        "häst träningsapp",
        "ryttarcoaching app",
        "träningsdagbok häst",
        "dressyrprotokoll analysera",
        "hästtränare programvara",
      ],
    },
    hero: {
      eyebrow: "Vägledning · tränarprogram",
      breadcrumbLabel: "Tränarapp",
      title: "Tränarapp häst: komplett vägledning för instruktörer och coacher.",
      intro: "En tränare eller instruktör jonglerar med kombinationer, lektioner, videor, mål och tävlingar. Jämför de bästa tränarapparna för hästmänniskor och välj den plattform som håller jämna steg med din coaching även 2026.",
      pills: [
        {
          icon: "Target",
          label: "Mål & planering",
        },
        {
          icon: "Video",
          label: "Videoanalys",
        },
        {
          icon: "TrendingUp",
          label: "Framsteg",
        },
        {
          icon: "Users",
          label: "Kunder/kombinationer",
        },
      ],
      ctas: [
        {
          label: "Börja gratis som tränare",
          href: "#start",
          primary: true,
        },
        {
          label: "Till jämförelsetabellen",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Varför WhatsApp-coaching sätter käppar i hjulet för tränare.",
      lead: "De flesta tränare arbetar med separata verktyg: WhatsApp för kommunikation, ett anteckningsblock för lektioner, YouTube eller WeTransfer för videor och Excel för tävlingsresultat. Med 5 ryttare fungerar det. Med 20 ryttare försvinner information, glöms mål bort och tappas greppet om individuell utveckling.",
      items: [
        "Vad är Anouks mål för den här säsongen?",
        "Vilken video skickade jag till Bram förra månaden?",
        "Har Lara sett protokollanalysen från hennes senaste tävling?",
        "Vilken kombination tränar hur ofta i veckan?",
        "Har ägaren till Stardust läst mina träningsinstruktioner?",
        "När gav jag senast feedback på fluktuerande impuls?",
      ],
    },
    what: {
      title: "Vad är en tränarapp för häst och ryttare?",
      lead: "En tränarapp kombinerar ett coaching-CRM (kombinationer, lektioner, mål), en träningslogg per häst, videofeedback, tävlingsplanering och protokollanalys. Inget mer löst WhatsApp/YouTube/Excel — utan en plattform där tränare och ryttare arbetar tillsammans.",
      targetGroupsTitle: "För vilken typ av tränare är detta avsett?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressyrinstruktör",
          body: "Skanna protokoll, koppla dommarkommentarer till träningsmål, se framsteg.",
        },
        {
          icon: "Activity",
          title: "Hopptränar",
          body: "Baneplanering, rondsfeedback, höjdhantering per häst.",
        },
        {
          icon: "Award",
          title: "Eventingcoach",
          body: "Tre grenar, tre planeringar — alla synliga sida vid sida.",
        },
        {
          icon: "TrendingUp",
          title: "Prestandacoach (sport)",
          body: "EPI-spårning, tävlingar, mål — för elitidrottare och deras team.",
        },
        {
          icon: "Users",
          title: "Ridinstruktör",
          body: "Grupplektioner och individuell coaching i en och samma app.",
        },
        {
          icon: "Heart",
          title: "Rekreationscoach",
          body: "Ridterapi, nybörjare, ägare med en häst.",
        },
      ],
    },
    criteria: {
      title: "Vad ska en bra tränarapp uppfylla?",
      lead: "Träning är ett mänskligt arbete, men rätt verktyg gör dig 30–50 % effektivare och hjälper ryttare att utvecklas även mellan lektionerna.",
      items: [
        {
          icon: "Users",
          title: "Kombinationshantering",
          body: "Häst + ryttare som en enhet, med nivå, mål, framsteg och historik.",
        },
        {
          icon: "ClipboardList",
          title: "Lektionsanteckningar & mål",
          body: "En anteckning per lektion med fokuspunkter, kopplad till långsiktiga mål.",
        },
        {
          icon: "Video",
          title: "Videofeedback",
          body: "Ladda upp video, tagga moment, lägg till talad eller skriven feedback.",
        },
        {
          icon: "Target",
          title: "Tävlings- & protokollanalys",
          body: "Skanna protokoll (KNHS/FEI), se poäng per moment, dommarkommentarer och trender.",
        },
        {
          icon: "Calendar",
          title: "Planering & lektionskort",
          body: "Kalender, betalningar, abonnemang och automatiska påminnelser.",
        },
        {
          icon: "Share2",
          title: "Kommunikation till ryttare",
          body: "Ryttaren ser sin egen sida med lektioner, videor, mål och feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andra tränarapper.",
      lead: "Vissa tränarverktyg fokuserar på att ersätta WhatsApp, andra på protokollanalys. EquiSight kombinerar båda med ett riktigt hästdossier — så att ryttaren utvecklas även mellan lektionerna.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Starta gratis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinationshantering",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lektionsanteckningar & feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Långsiktiga mål",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Videouppladdning + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI-protokollskanning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (prestationsindex)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tävlingskalender",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ryttarportal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Lektionskort / abonnemang",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Onlinebetalningar",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrerat hästdossier",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hovsmid/veterinär synlig",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "För instruktör OCH ryttare",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Flera hästar per ryttare",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Jämförelse baserad på offentligt tillgängliga funktioner i januari 2026. EquiSight är unikt vad gäller protokollanalys + EPI och kombinerar detta med allmän hästhantering.",
    },
    why: {
      title: "Varför EquiSight erbjuder en annan tränarupplevelse.",
      lead: "De flesta tränarverktyg slutar där lektionen tar slut. EquiSight fortsätter — i hästdossiret, i tävlingsanalysen, i samarbetet med veterinären och ägaren.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokollskanning → träningsmål",
          body: "Skanna ett KNHS-protokoll och se direkt vilka moment som behöver uppmärksamhet. Mål genereras automatiskt.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach förstärker ditt öga",
          body: "Data från flera lektioner, tävlingar och protokoll visar mönster som du inte kan hålla i huvudet.",
        },
        {
          icon: "Share2",
          title: "Integrerat med hästen",
          body: "Tränaren ser vaccinationer, hovsmid och skadehistorik för hästen — planera inte träning under rehabilitering.",
        },
      ],
    },
    nicheA: {
      eyebrow: "För dressyr och hoppning",
      title: "Vad ett coachingdossier i EquiSight innehåller.",
      lead: "Per kombination får du ett coaching-flöde som håller ihop allt — aldrig mer tappa bort saker i WhatsApp.",
      items: [
        "Lektionsanteckningar med fokuspunkter per session",
        "Långsiktiga mål + milstolpar",
        "Videouppladdning med tidskods-kommentarer",
        "KNHS/FEI-protokollskanning med poäng",
        "Dommarkommentarer kopplade till träning",
        "Tävlingsresultat och EPI-trend",
        "Kundkontakt och lektionshistorik",
        "Lektionskort / abonnemang / fakturor",
        "Framstegsdiagram per gren",
        "Delad åtkomst med hästägaren",
      ],
      ctaLabel: "Se tränarmodulen",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Från WhatsApp + YouTube till EquiSight Trainer.",
      lead: "Konkret: så här förändras ditt coachingflöde.",
      rows: [
        {
          before: "WhatsApp med lösa videolänkar",
          after: "Video med tidskodsfeedback i dossier",
        },
        {
          before: "Anteckningsblock per ryttare",
          after: "Coachinglogg med mål + historik",
        },
        {
          before: "Excel med tävlingspoäng",
          after: "EPI-graf + protokollanalys",
        },
        {
          before: "Muntliga mål",
          after: "Milstolpar med framstegsindikator",
        },
        {
          before: "Separat faktureringsverktyg",
          after: "Lektioner + iDEAL + abonnemang i appen",
        },
        {
          before: "E-post till ägaren om framsteg",
          after: "Ägaren följer i sin egen vy",
        },
      ],
    },
    helper: {
      title: "Vilken tränarapp passar dig?",
      lead: "5 frågor för att se om ett specialiserat coachingverktyg tillför värde för din verksamhet.",
      questions: [
        {
          id: "clients",
          q: "Hur många aktiva kombinationer coachar du?",
          options: [
            {
              label: "Färre än 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Fler än 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Vad är din huvudgren?",
          options: [
            {
              label: "Dressyr",
              score: 3,
            },
            {
              label: "Hoppning",
              score: 2,
            },
            {
              label: "Rekreation / blandat",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Använder du video i din coaching?",
          options: [
            {
              label: "Sällan",
              score: 0,
            },
            {
              label: "Ibland (manuellt)",
              score: 2,
            },
            {
              label: "Ofta — strukturerat",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Coachar du tävlingsryttare?",
          options: [
            {
              label: "Nej, rekreation",
              score: 0,
            },
            {
              label: "Ibland tävlingar",
              score: 2,
            },
            {
              label: "Mycket — startlistor centralt",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vill du mäta din coaching?",
          options: [
            {
              label: "Nej, intuition räcker",
              score: 0,
            },
            {
              label: "Ja, men ingen tid",
              score: 2,
            },
            {
              label: "Ja — datadriven coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ett enkelt verktyg eller till och med WhatsApp räcker — för nu.",
          body: "För färre än 5 ryttare utan mycket video eller tävlingar är en coachingapp överdrivet. EquiSight startar gratis, så du kan prova när din verksamhet växer.",
          cta: "Starta gratis",
        },
        mid: {
          title: "EquiSight Trainer gör dig strukturellt effektivare.",
          body: "Med 5–15 kombinationer förlorar du varje månad timmar på WhatsApp och lösa videor. EquiSight samlar allt, skannar protokoll automatiskt och ser till att ryttare alltid kan se sin feedback igen.",
          cta: "Prova tränarmodulen",
        },
        high: {
          title: "EquiSight är byggt för din coachingskala.",
          body: "Många ryttare, video, tävlingar och datadriven coaching: det är precis här EquiSight utmärker sig. EPI + protokollskanning + hästdossier ger dig ett försprång som konkurrenter inte har.",
          cta: "Boka en demo för din coachingverksamhet",
        },
      },
    },
    faqTitle: "Vanliga frågor om tränarapper",
    faq: [
      {
        q: "Vad är den bästa tränarappen för häst och ryttare?",
        a: "För ren kommunikation räcker många verktyg (till och med WhatsApp). För mål, videoanalys, protokollskanning, tävlingsspårning och kundhantering i ett enda verktyg är EquiSight den mest kompletta lösningen — framför allt eftersom det även håller koll på själva hästen, inte bara kombinationen.",
      },
      {
        q: "Kan EquiSight läsa tävlingsprotokoll automatiskt?",
        a: "Ja. Ladda upp ett KNHS- eller FEI-protokoll så extraherar EquiSight poäng per moment, dommarkommentarer och kopplar detta till kombinationen. Du ser trender över flera tävlingar.",
      },
      {
        q: "Vad är EPI (Equestrian Performance Index)?",
        a: "EPI är ett EquiSight-poäng som omvandlar flera tävlingsresultat till ett jämförbart prestationsindex. På så sätt ser du verkliga framsteg genom olika klasser och domare.",
      },
      {
        q: "Kan ryttare boka och betala mina lektioner själva?",
        a: "Ja. Ryttare loggar in, ser tillgängliga lektionstider, köper lektionskort och betalar via iDEAL. Du bestämmer själv vad du vill erbjuda.",
      },
      {
        q: "Fungerar det även för en instruktör som arbetar runt en ridskola?",
        a: "Ja. Du kan arbeta som frilansande tränare med egna kunder utan att koppla ett ridskolekonts. Kunderna betalar dig direkt.",
      },
      {
        q: "Kan jag migrera befintliga videor och anteckningar?",
        a: "Videor kan du ladda upp per kombination eller via ett batch-uppladdningsverktyg. Anteckningar importeras via CSV. Vi hjälper aktiva tränare med en engångsmigrering.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guider & vägledningar för hästhanteringsprogram | EquiSight",
      description: "Alla EquiSight-guider på ett ställe: jämförelser av hästhantering, avelsverksamhet, ridskola och tränarprogram samt vägledningar för 2026.",
      keywords: [
        "häst­programvaruguider",
        "vägledning för hästhantering",
        "jämföra avels­programvara",
        "ridskola programvara guide",
        "tränarapp jämförelse",
      ],
    },
    hub: {
      eyebrow: "Hub · guider",
      breadcrumbLabel: "Guider",
      title: "Fyra kompletta guider för att välja rätt hästprogramvara.",
      intro: "En djupgående vägledning för varje målgrupp: jämförelsetabeller, kriterier, exempel och interaktiva quiz. Klicka dig vidare till den guide som passar din situation, eller utforska de fördjupande artiklarna under varje kluster.",
      stats: {
        guides: "4 vägledningar",
        articles: "15 fördjupande artiklar",
        fair: "Ärlig jämförelse",
      },
      readMoreCta: "Läs den kompletta guiden",
      relatedHeading: "Fördjupande artiklar",
      articlesCountSingular: "{{count}} fördjupande artikel",
      articlesCountPlural: "{{count}} fördjupande artiklar",
      articlesCountAria: "Antal klusterartiklar",
      lastUpdatedPrefix: "Uppdaterad",
      lastUpdatedAria: "Datum för senaste uppdatering av detta kluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Vägledning för hästhanteringsapp",
        blurb: "Jämför de mest kända hästhanteringsapparna och ta reda på vilken som passar ägare, stall eller avelsverksamhet. Inkluderar en ärlig jämförelsetabell och en vägledning med 5 frågor.",
        audience: "För hästägare, stallägare och alla hästmänniskor som vill ha bättre överblick.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Jämförelse av avels­programvara",
        blurb: "Från stocyklus till fölutveckling: se vilken avels­programvara som verkligen fungerar för ditt antal ston, din avelsstrategi och studbooks krav.",
        audience: "För (hobby)uppfödare, stuterier och hingststationer.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Vägledning för ridskole­programvara",
        blurb: "Lektionsplanering, ryttaradministration, ägarportal och fakturering — i ett och samma verktyg. Jämför alternativen för ridskolor och installs­stall 2026.",
        audience: "För ridskolor, inackorderingsstall och ridsportsföretag.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Vägledning för tränarapp",
        blurb: "Coaching-CRM, videofeedback, skanning av KNHS-protokoll och mål per kombination. Vilken tränarapp passar din coachingverksamhet?",
        audience: "För instruktörer, tränare och coacher.",
      },
    ],
    closing: {
      eyebrow: "Varför dessa guider",
      title: "Ärlig jämförelse, inte bara priser.",
      body1: "Många \"jämförelsesidor\" är förtäckta annonser. Våra guider ställer funktioner, målgrupper och konkurrenter mot varandra på samma sätt som en oberoende kunskapskälla skulle göra. EquiSight lyfts naturligtvis fram som en komplett lösning, men du får också en ärlig bild av var andra appar är starkare.",
      body2: "De fördjupande artiklarna under varje guide besvarar de konkreta frågor som uppstår vid valet: \"När görs första ultraljudet efter insemination\", \"Hur automatiserar jag fakturering för ridskolan\", \"Hur analyserar jag ett tävlingsprotokoll\". Ingen marknadsföringsfluff, utan ren praktik.",
    },
    hubName: "EquiSight Guider",
  },
  ui: {
    sectionEyebrows: {
      pains: "Varför det gör ont",
      basics: "Grunderna",
      criteria: "Vad gör det bra?",
      comparison: "Ärlig jämförelse",
      why: "Skillnaden",
      beforeAfter: "Från fragmentering till överblick",
      helper: "5 frågor",
    },
    table: {
      feature: "Funktion",
      today: "Idag",
      withEquisight: "Med EquiSight",
    },
    helper: {
      questionLabel: "Fråga {{current}} av {{total}}",
      answerPrompt: "Svara på den {{count}} återstående frågan för att se en rekommendation.",
      answerPromptPlural: "Svara på de {{count}} återstående frågorna för att se en rekommendation.",
      resultEyebrow: "Ditt resultat",
    },
    targetGroupsFallback: "Vem är det här för?",
    faqTitleFallback: "Vanliga frågor",
  },
};

export default CORNERSTONES;
